import React, { JSX } from 'react';
import { observer } from 'mobx-react';
import { Element as ScrollTo } from 'react-scroll/modules';
import Error from '../../Components/UI/Messages/Error';
import { Warning } from '../../Components/UI/Messages/Warning';
import fallback from '../../../_Translations/generated/package.en.t.json';
import Keys from '../../../_Translations/generated/package.en.t.json.keys';
import useTranslation from '../../Hooks/useTranslation';
import PackageStore from './PackageStore';

const ErrorDisplay = observer(
  ({ store }: { store: PackageStore }): JSX.Element => {
    const { t } = useTranslation('package', fallback, Keys);

    return (
      <>
        <ScrollTo name={store.scrollElementGlobalError}>
          {store.error && <Error message={t(store.error)} />}
          {!store.error && store.warning && <Warning message={t(store.warning)} />}
        </ScrollTo>
      </>
    );
  }
);

export default ErrorDisplay;
